import { render, staticRenderFns } from "./ActivitiesComponent.vue?vue&type=template&id=1a17afba&"
import script from "./ActivitiesComponent.vue?vue&type=script&lang=js&"
export * from "./ActivitiesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QExpansionItem} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QExpansionItem})
